import { closest } from '@jotforminc/utils';
import { hasClass, triggerEvent } from './utils';

const selectors = {
  summaryWrapper: '.product-summary',
  listWrapper: '.product-summary__left',
  itemWrapper: '.product-mini',
  backButton: '.product-summary__back'
};

export default class SummaryPage {
  constructor(question, shoppingBag) {
    this.question = question;
    this.shoppingBag = shoppingBag;

    this.wrapper = question.querySelector(selectors.summaryWrapper);
    this.listWrapper = this.wrapper.querySelector(selectors.listWrapper);
    this.backButton = this.wrapper.querySelector(selectors.backButton);

    this.backButtonClick = this.backButtonClick.bind(this);
    this.editButtonClick = this.editButtonClick.bind(this);
    this.removeButtonClick = this.removeButtonClick.bind(this);

    this.backButton.addEventListener('click', this.backButtonClick);
  }

  makeList(products, formProducts) {
    this.emptyList();

    products.forEach((p) => {
      var inpt = document.querySelector(`#${p}`);
      if (inpt && inpt.checked) {
        const productID = this.getProductID(p);
        // check if it has subproducts
        if (this.hasSubProduct(productID, formProducts)) {
          const subProducts = this.getSubProducts(productID, formProducts, p);

          subProducts.forEach((sub) => {
            this.makeListItem(Object.assign({}, sub, { productID: p }), true);
          });
        } else {
          const product = global.JotForm.prices[p];
          const hasSpecialQuantityPricing = product.specialPriceField && product.specialPriceField.indexOf('quantity') > -1;

          const quantity = this.getQuantity(p);
          const name = this.getProductName(productID, formProducts);
          const price = this.getProductPrice(p);

          this.makeListItem({ name, price, quantity, productID: p, hasSpecialQuantityPricing });
        }

        if (typeof global.PaymentStock !== 'undefined') {
          global.PaymentStock.handleStockManagement();
        }
      }
    });
    if (global.FormTranslation && global.FormTranslation.setOriginalDynamicFormElements) {
      global.FormTranslation.setOriginalDynamicFormElements();
    }
    this.shoppingBag.setHeight(this.wrapper);
  }

  makeListItem(item, isSubProduct) {
    const { name, price, quantity, hasSpecialQuantityPricing } = item;
    const pid = this.getProductID(item.productID);

    const productMini = document.createElement('div');
    productMini.setAttribute('class', 'product-mini');

    const total = hasSpecialQuantityPricing ? price : quantity * price;

    const productMiniHeader = this.makeProductMiniHeader(name, total, pid);
    productMini.appendChild(productMiniHeader);

    const productMiniBody = document.createElement('div');
    productMiniBody.setAttribute('class', 'product-mini__body');

    const productMiniOptions = document.createElement('div');
    productMiniOptions.setAttribute('class', 'product-mini__options');

    const quantityOption = this.makeProductMiniOption('Quantity', quantity, `product-mini__options__quantity_${pid}`);
    productMiniOptions.appendChild(quantityOption);

    const productOptions = this.shoppingBag.formProducts.filter(p => p.pid === pid)[0];

    if ('options' in productOptions && productOptions.options.length > 0) {
      productOptions.options.filter(p => p.expanded).forEach((expanded) => {
        const expandedIndex = item.quantityFieldID.split('_')[4];
        const miniOption = this.makeProductMiniOption(expanded.name, expanded.properties.split('\n')[expandedIndex], `product-mini__options__expanded_${pid}-${expandedIndex}`);
        productMiniOptions.appendChild(miniOption);
      });
      productOptions.options.forEach((opt, i) => {
        if (opt.type !== 'quantity' && !opt.expanded) {
          let fieldParameters = [];
          if (isSubProduct) {
            fieldParameters = item.quantityFieldID.split('_');
            fieldParameters[2] = 'custom';
            fieldParameters[5] = i;
          } else {
            fieldParameters = item.productID.split('_');
            fieldParameters.splice(2, 0, 'custom');
            fieldParameters.push(i);
          }
          const valueField = fieldParameters.join('_');
          const value = this.shoppingBag.qLine.querySelector(`#${valueField}`).value;
          const miniOption = this.makeProductMiniOption(opt.name, value, `product-mini__options__others_${pid}-${i}`);
          productMiniOptions.appendChild(miniOption);
        }
      });
    }

    productMiniBody.appendChild(productMiniOptions);

    const productMiniActions = this.makeProductMiniActions(item, isSubProduct);

    productMiniBody.appendChild(productMiniActions);

    productMini.appendChild(productMiniBody);

    this.listWrapper.appendChild(productMini);
  }

  getProductID(product) {
    var pid = product.split('_')[2];
    return pid;
  }

  getQuantity(product) {
    const hasQuantityField = global.JotForm.prices[product] && global.JotForm.prices[product].quantityField;
    const quantity = hasQuantityField ? this.shoppingBag.qLine.querySelector(`#${global.JotForm.prices[product].quantityField}`).value : 1;

    return quantity;
  }

  getProductName(pid, formProducts) {
    const product = this.getProductFromID(pid, formProducts);
    return product.name;
  }

  hasSubProduct(pid, formProducts) {
    const product = this.getProductFromID(pid, formProducts);
    return !!parseInt(product.hasExpandedOption, 10);
  }

  getSubProducts(productID, formProducts, p) {
    const expandedOption = this.getExpandedOption(productID, formProducts);

    return expandedOption.map((opt, optIndex) => {
      const subProduct = global.JotForm.prices[`${p}_${optIndex}`];
      const quantityField = this.shoppingBag.qLine.querySelector(`#${subProduct.quantityField}`);
      const quantity = parseInt(quantityField.value, 10);
      if (quantity < 1) return undefined;
      const productName = this.getProductName(productID, formProducts);
      // const optionNames = this.getSubProductOptionNames();
      if (subProduct.specialPriceField) {
        const hasSpecialQuantityPricing = subProduct.specialPriceField.indexOf('quantity') > -1;
        const subProductSelectedIndex = hasSpecialQuantityPricing ? quantity : subProduct.specialPriceField.split('_').pop();
        const specialPrice = parseFloat(subProduct.specialPriceList[parseInt(subProductSelectedIndex, 10)], 10);

        return {
          quantity: quantity,
          quantityFieldID: quantityField.id,
          price: specialPrice,
          name: productName,
          hasSpecialQuantityPricing: hasSpecialQuantityPricing
        };
      }
      return {
        quantity: quantity,
        quantityFieldID: quantityField.id,
        price: subProduct.price,
        name: productName
      };
    }).filter(e => e);
  }

  getExpandedOption(pid, formProducts) {
    return this.getProductFromID(pid, formProducts).options.find(
      p => p.expanded
    ).properties.split('\n');
  }

  getProductFromID(pid, formProducts) {
    return formProducts.find(prod => prod.pid === pid);
  }

  makeNameContainer(productName, quantity) {
    var container = document.createElement('div');
    container.setAttribute('class', 'itemName');
    container.innerHTML = `${quantity} x ${productName}`;
    return container;
  }

  getProductPrice(productID) {
    if (!global.JotForm.prices[productID]) return 0;

    const product = global.JotForm.prices[productID];
    if (!product.specialPriceField) return product.price;

    const specialPriceField = this.shoppingBag.qLine.querySelector(`#${product.specialPriceField}`);
    const specialPriceIndex = specialPriceField.selectedIndex;
    return parseFloat(product.specialPriceList[specialPriceIndex], 10);
  }

  makePriceContainer(price, quantity) {
    const container = document.createElement('div');
    container.setAttribute('class', 'itemPrice');
    container.innerHTML = `${this.curr()} ${price * quantity}`;

    return container;
  }

  makeEditButton(product) {
    const editButton = document.createElement('button');
    editButton.setAttribute('type', 'button');
    editButton.setAttribute('class', 'itemCta');
    editButton.innerHTML = 'EDIT';
    editButton.setAttribute('data-id', product);

    editButton.addEventListener('click', this.editButtonClick);

    return editButton;
  }

  makeProductMiniHeader(name, price, id) {
    const { decimal, dSeparator, tSeparator } = global.JotForm.currencyFormat;
    const productMiniHeader = document.createElement('div');
    productMiniHeader.setAttribute('class', 'product-mini__header');

    const productMiniTitle = document.createElement('div');
    productMiniTitle.setAttribute('class', 'product-mini__title payment-text dynamic-form-element');
    productMiniTitle.setAttribute('id', `product-mini__title-${id}`);
    productMiniTitle.textContent = name;

    const productMiniPrice = document.createElement('div');
    productMiniPrice.setAttribute('class', 'product-mini__price');

    // Number.formatMoney is implemented on jotform.js
    productMiniPrice.textContent = `${this.curr()}${price.formatMoney(decimal, dSeparator, tSeparator)}`;

    productMiniHeader.appendChild(productMiniTitle);
    productMiniHeader.appendChild(productMiniPrice);

    return productMiniHeader;
  }

  makeProductMiniActions(product, isSubProduct) {
    const productMiniActions = document.createElement('div');
    productMiniActions.setAttribute('class', 'product-mini__actions');

    const productMiniRemoveButton = document.createElement('div');
    productMiniRemoveButton.setAttribute('class', 'product-mini__button product-mini__button--remove');
    productMiniRemoveButton.setAttribute('data-id', product.productID);
    productMiniRemoveButton.setAttribute('tabindex', 0);
    if (isSubProduct) productMiniRemoveButton.setAttribute('data-quantity-id', product.quantityFieldID);
    productMiniRemoveButton.addEventListener('click', this.removeButtonClick);
    productMiniRemoveButton.addEventListener('keypress', this.buttonKeyPress);

    const productMiniEditButton = document.createElement('div');
    productMiniEditButton.setAttribute('class', 'product-mini__button product-mini__button--edit');
    productMiniEditButton.setAttribute('data-id', product.productID);
    productMiniEditButton.setAttribute('tabindex', 0);
    productMiniEditButton.addEventListener('click', this.editButtonClick);
    productMiniEditButton.addEventListener('keypress', this.buttonKeyPress);

    const getProduct = document.querySelector(`[data-input="${product.productID}"]`)
    if (!(getProduct && getProduct.classList.contains('product--required') && getProduct.classList.contains('sold_out_product'))) {
      productMiniActions.appendChild(productMiniRemoveButton);
    }
    
    productMiniActions.appendChild(productMiniEditButton);

    return productMiniActions;
  }

  makeProductMiniOption(name, value, id) {
    const productMiniOption = document.createElement('div');
    productMiniOption.setAttribute('class', 'product-mini__option');

    const productMiniOptionName = document.createElement('span');
    productMiniOptionName.setAttribute('class', 'product-mini__option-value payment-text dynamic-form-element');
    productMiniOptionName.setAttribute('id', id);
    productMiniOptionName.textContent = `${name}`;

    const productMiniOptionColon = document.createElement('span');
    productMiniOptionColon.setAttribute('class', 'product-mini__option-name');
    productMiniOptionColon.textContent = ':';

    const productMiniOptionValue = document.createElement('span');
    productMiniOptionValue.setAttribute('class', 'product-mini__option-value');
    productMiniOptionValue.textContent = value;

    productMiniOption.appendChild(productMiniOptionName);
    productMiniOption.appendChild(productMiniOptionColon);
    productMiniOption.appendChild(productMiniOptionValue);

    return productMiniOption;
  }

  editButtonClick(e) {
    this.shoppingBag.backToProductList('summary', true);

    const inputId = e.target.getAttribute('data-id');
    this.shoppingBag.openProductDetails(inputId);
  }

  closeSummaryPage() {
    this.shoppingBag.slideUp(this.wrapper, true);
    this.wrapper.style.display = 'none';
  }

  openSummaryPage() {
    this.shoppingBag.slideDown(this.wrapper);
    this.wrapper.style.display = 'block';
  }

  makeRemoveButton(product, isSubProduct) {
    const removeButton = document.createElement('button');
    removeButton.setAttribute('type', 'button');
    removeButton.setAttribute('class', 'itemCta');
    removeButton.innerHTML = 'REMOVE';
    removeButton.setAttribute('data-id', product.productID);
    if (isSubProduct) removeButton.setAttribute('data-quantity-id', product.quantityFieldID);
    removeButton.addEventListener('click', this.removeButtonClick);

    return removeButton;
  }

  removeButtonClick(e) {
    const removeButton = e.target;

    const productID = removeButton.getAttribute('data-id');
    const product = this.shoppingBag.qLine.querySelector(`li[data-input="${productID}"]`);
    const hasSubProduct = hasClass(product, 'js-hasSubProduct');
    const isProductRequired = hasClass(product, 'product--required');
    const input = this.question.querySelector(`#${productID}`);

    if ((!hasSubProduct && input.disabled) || isProductRequired) return;

    this.removeItemFromList(removeButton);

    // this.shoppingBag.setHeight(this.wrapper);
    this.wrapper.style.height = 'auto';

    if (hasSubProduct) {
      // change subProduct Quantity to zero
      const quantityField = this.shoppingBag.qLine.querySelector(`#${removeButton.getAttribute('data-quantity-id')}`);
      quantityField.value = 0;
      triggerEvent(quantityField, 'change');
    }

    if (hasSubProduct && this.shoppingBag.hasSelectedSubProductItem(product)) {
      this.shoppingBag.updateCartItems();
      return;
    }
    this.shoppingBag.removeFromBag(product);
    this.shoppingBag.backToProductList('summary');
  }

  buttonKeyPress(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      e.stopPropagation();
      e.target.click();
    }
  }

  backButtonClick() {
    this.shoppingBag.backToProductList('summary');
  }

  emptyList() {
    this.listWrapper.innerHTML = '';
  }

  isEditButtonVisible(product) {
    return !hasClass(this.shoppingBag.qLine.querySelector(`[data-input="${product}"]`), 'js-zeroOption');
  }

  removeItemFromList(removeButton) {
    const summaryList = closest(removeButton, selectors.listWrapper, '.jfCard');
    const summarListItem = closest(removeButton, selectors.itemWrapper, selectors.itemWrapper);
    if (summaryList && summarListItem) summaryList.removeChild(summarListItem);
  }

  curr() {
    var currDisplay = '';
    switch (this.shoppingBag.currency) {
      case 'TRY':
        currDisplay = 'TL';
        break;
      case 'USD':
        currDisplay = '$';
        break;
      default:
        currDisplay = this.shoppingBag.currency;
        break;
    }

    return currDisplay;
  }
}
